import type { ExerciseQueue } from 'api/rest/exerciseQueues/exerciseQueues.types';
import type { Section } from 'api/rest/sections/sections.types';

export type OnGoScreenType = 'loading' | 'initialize' | 'exercise' | 'summary';

export type ResolveOnGoScreenParams = {
  activeQueue: ExerciseQueue | null | undefined;
  sectionsData: Section[] | undefined;
  isActiveQueueLoading: boolean;
  isActiveQueueFetching: boolean;
  isActiveQueueError: boolean;
};

/**
 * Derives which On Go screen to show from the active queue query and sections.
 * Waits for the active queue fetch to finish so stale React Query cache cannot
 * flash summary before a refetch that returns no active queue.
 */
export const resolveOnGoScreen = ({
  activeQueue,
  sectionsData,
  isActiveQueueLoading,
  isActiveQueueFetching,
  isActiveQueueError,
}: ResolveOnGoScreenParams): OnGoScreenType => {
  if (isActiveQueueLoading || isActiveQueueFetching) {
    return 'loading';
  }

  if (activeQueue === undefined) {
    if (isActiveQueueError) {
      return sectionsData ? 'initialize' : 'loading';
    }
    return 'loading';
  }

  if (activeQueue === null) {
    return sectionsData ? 'initialize' : 'loading';
  }

  if (activeQueue.completedAt || !activeQueue.currentItem) {
    return 'summary';
  }

  return 'exercise';
};
